import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './ButtonGroup.styles.js';

var defaultProps = {
  direction: "horizontal"
};
var ButtonGroupPresentation = fComp(function (_ref) {
  var _cleanupClassObject, _cleanupClassObject2;
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    noMargin = _ref.noMargin,
    isStencilHost = _ref.isStencilHost,
    direction = _ref.direction,
    align = _ref.align,
    viewport = _ref.viewport,
    horizontalAlignment = _ref.horizontalAlignment;
  var isDirectionVertical = direction === "vertical" || direction === "flip-xs" && viewport === "xs" || direction === "flip-sm" && (viewport === "sm" || viewport === "xs") || direction === "flip-md" && (viewport === "md" || viewport === "sm" || viewport === "xs");
  var alignment = align || horizontalAlignment || (isDirectionVertical ? "center" : "left");
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(isDirectionVertical ? "vertical" : "horizontal"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(alignment), true), _cleanupClassObject2))
  }, children));
}, defaultProps);
ButtonGroupPresentation.displayName = "ButtonGroupPresentation";

export { ButtonGroupPresentation, defaultProps };
